import React, {useCallback, useState} from "react";
import {Modal, FormControl} from "@mui/material";
import {useViewController} from "data/services/locator";
import {IModalController} from "views/components/modals/modal.controller";
import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";
import {ModalButton, ModalContent} from "views/components/modals/common";
import {observer} from "mobx-react";
import {CheckboxLabel, InputCheckbox} from "views/components/common";
import {useTranslation} from "react-i18next";
import styled from "@emotion/styled";
import logoEN from "assets/img/logo-landing-en.png";
import logoFR from "assets/img/logo-landing-fr.png";
import {Exist} from "views/components/Exist";
import {useLocation} from "react-router";
import {eq} from "lodash";

const Logo = styled.img`
	width: 220px;
	height: auto;
	margin-bottom: 20px;
`;

const FormControlStyled = styled(FormControl)`
	span {
		color: #ffffff;
	}

	svg {
		fill: #ffffff;
	}

	label {
		margin: 0;
	}
`;

const Title = styled.h3`
	font-size: 28px;
	margin-bottom: 20px;
`;

const CheckboxesWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ModalTerms: React.FC = observer(() => {
	const {t, i18n} = useTranslation();
	const location = useLocation();
	const {isModalOpen, handleTermsForm, userName, user} = useViewController<IModalController>(
		Bindings.ModalController
	);

	const isCreate = location.pathname.includes("terms");
	const isOpen = isModalOpen(ModalType.TERMS) && !isCreate;

	const [disabledSubmit, setStateSubmit] = useState(true);

	const onChangeTerms = useCallback(() => {
		setStateSubmit(!disabledSubmit);
	}, [disabledSubmit, setStateSubmit]);

	const notificationsText = t("form.sso.notifications");
	const ssoText = t("form.sso.opt_in");
	const termsText = t("form.sso.terms", {
		terms_text: `<a href="${
			process.env.PUBLIC_URL
		}/help/terms" target="_blank" rel="noopener noreferrer">
				${t("form.sso.terms_link")}
			</a>`,
	});

	return (
		<Modal open={isOpen}>
			<form onSubmit={handleTermsForm}>
				<ModalContent>
					<Exist when={eq(i18n.language, "en")}>
						<Logo src={logoEN} alt="CFL PickEm" />
					</Exist>
					<Exist when={eq(i18n.language, "fr")}>
						<Logo src={logoFR} alt="LCF Jeu Des Predictions" />
					</Exist>
					<Title>
						{t("form.sso.title")} {userName}
					</Title>

					<CheckboxesWrapper>
						<Exist when={!user?.optInGZ}>
							<FormControlStyled>
								<CheckboxLabel>
									<InputCheckbox name="marketingEmails" />
									{/*Disabled due html come from Loco and should be safety*/}
									{/*eslint-disable-next-line*/}
									<span dangerouslySetInnerHTML={{__html: ssoText}} />
								</CheckboxLabel>
							</FormControlStyled>
						</Exist>

						<FormControlStyled>
							<CheckboxLabel>
								<InputCheckbox name="marketingOptInPickem" />
								{/*Disabled due html come from Loco and should be safety*/}
								{/*eslint-disable-next-line*/}
								<span dangerouslySetInnerHTML={{__html: notificationsText}} />
							</CheckboxLabel>
						</FormControlStyled>

						<FormControlStyled>
							<CheckboxLabel>
								<InputCheckbox name="terms" required onChange={onChangeTerms} />
								{/*Disabled due html come from Loco and should be safety*/}
								{/*eslint-disable-next-line*/}
								<span dangerouslySetInnerHTML={{__html: termsText}} />
							</CheckboxLabel>
						</FormControlStyled>
					</CheckboxesWrapper>

					<ModalButton fullWidth type="submit" disabled={disabledSubmit}>
						{t("modal.sso.button")}
					</ModalButton>
				</ModalContent>
			</form>
		</Modal>
	);
});
